import { useNavigate, useSearchParams } from "react-router-dom";
import AuthContentWrapper from "./components/AuthContentWrapper";
import CustomIcon from "../../common/components/image/CustomIcon";
import { Column, Padding, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { C3Text, T1Text } from "../../common/components/text/CustomText";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import Translate from "../../common/translate/Translate";
import { useEffect, useState } from "react";
import LocalStorageKey from "../../common/enums/LocalStorageKey";
import { Theme } from "../../common/Theme";

function TermDetailPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");
    const selectedCountry = localStorage.getItem(LocalStorageKey.server) || "TH";
    const [htmlContent, setHtmlContent] = useState("");

    useEffect(() => {
        const fetchHtmlContent = async () => {
            try {
                const response = await fetch(`/html/${type}_${selectedCountry}.html`);
                if (response.ok) {
                    const html = await response.text();
                    setHtmlContent(html);
                } else {
                    console.error("Failed to load terms file.");
                    setHtmlContent("<p>Failed to load terms and conditions.</p>");
                }
            } catch (error) {
                console.error("Error fetching terms file:", error);
                setHtmlContent("<p>An error occurred while loading the terms and conditions.</p>");
            }
        };

        fetchHtmlContent();
    }, [type, selectedCountry]);

    function handleHistoryBack() {
        navigate(-1);
    }

    return (
        <AuthContentWrapper
            contentPadding={"20px"}
            contentMaxHeight={"816px"}
            header={
                <>
                    <CustomIcon iconName={"undo"} size={"36px"} onClick={handleHistoryBack} cursor={"pointer"} />
                    <SizedBox height={"6px"} />
                    <Column justifyContent={"center"} padding={"0 40px"}>
                        <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                            {Translate("auth.terms.title")}
                        </T1Text>
                        <SizedBox height={"44px"} />
                    </Column>
                </>
            }
        >
            <Padding padding={"0 40px"}>
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                <SizedBox width={"100%"} height={"32px"} />
                <FullWidthButton
                    onClick={() => navigate(-1)}
                    text={"Ok"}
                    backgroundColor={Theme.color.white}
                    isActive={true}
                />
                <SizedBox height={"20px"} />
                <Row width={"100%"} justifyContent={"center"} alignItem={"center"}>
                    <C3Text fontColor={Theme.color.gray500}>Copyright © LG Electronics. All Rights Reserved.</C3Text>
                </Row>
                <SizedBox height={"42px"} />
            </Padding>
        </AuthContentWrapper>
    );
}

export default TermDetailPage;
